import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-01db7a84"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "audio-box"
};
const _hoisted_2 = {
  class: "audio"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "audio-name"
};
const _hoisted_7 = {
  key: 0,
  class: "audio-location"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-address"
}, null, -1));
const _hoisted_9 = {
  class: "number"
};
const _hoisted_10 = {
  class: "audio-menuv2"
};
const _hoisted_11 = ["onClick", "innerHTML"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  ref: "audioItem"
};
const _hoisted_14 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audioItem ${_ctx.$route.query.fid == 152288 ? 'nxbwgAudioItem' : ''}`)
  }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.audioList, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_2, [item.littleImage ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "img-cover",
      onClick: $event => $options.getAudioDetail(item)
    }, [_createElementVNode("img", {
      class: "audio-img",
      src: $options.getImg(item.littleImage, 236, 248)
    }, null, 8, _hoisted_4)], 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: _normalizeClass(["audio-desc", {
        'widthfixed': item.littleImage
      }])
    }, [_createElementVNode("div", {
      class: "desctop",
      onClick: $event => $options.getAudioDetail(item)
    }, [_createElementVNode("div", _hoisted_6, _toDisplayString($props.language ? item.en_antiqueName : item.antiqueName), 1), item.exhibitionLocation ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(item.exhibitionLocation), 1)])) : _createCommentVNode("", true)], 8, _hoisted_5), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
      class: "duration",
      onClick: $event => $options.getAudioDetail(item),
      innerHTML: item.desc
    }, null, 8, _hoisted_11), item.audioPath ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: $event => $options.clickPlay(index, item),
      class: "play"
    }, [_createElementVNode("i", {
      class: _normalizeClass($data.isPlaying && $data.currentIndex === index ? 'icon-pause' : 'icon-video1')
    }, null, 2)], 8, _hoisted_12)) : _createCommentVNode("", true)])], 2)]);
  }), 256))]), $data.audioPath ? (_openBlock(), _createElementBlock("audio", _hoisted_13, [_createElementVNode("source", {
    src: $data.audioPath,
    type: "audio/mpeg"
  }, null, 8, _hoisted_14)], 512)) : _createCommentVNode("", true)], 2);
}